import { Injectable } from '@angular/core';
import { MdSnackBar} from '@angular/material';
import {Router} from "@angular/router";

@Injectable()
export class ErrorManager {

  constructor(private router: Router,public snackBar: MdSnackBar) {
  }

  catchedError(errorBody:any){
    if(errorBody.status === 401){
      let snackBarRef = this.snackBar.open('로그인 정보가 만료되어, 로그인 화면으로 이동합니다.', '확인', {
        duration: 3000,
      });
      snackBarRef.afterDismissed().subscribe(() => {
        this.router.navigateByUrl('/common/sign-in/expired');
      });
    }
  }

}



// WEBPACK FOOTER //
// /Users/jihun.lee/Work/git-repos/client-accounting-intra-web/src/app/utils/errorManager.ts